import appConfig from '@bingads-webui-component-legacy/config/index';
import localStorage from '@bingads-webui-component-legacy/storage/localStorage';
import { LocalStorageKeys } from '@bingads-webui-campaign-react/campaign-onboarding-v2';
import { APP_STORE_TO_STORE_TYPE } from '@bingads-webui-campaign-react/unified-app-shared';

const localStorageKey = LocalStorageKeys.UnifiedAppCampaignAdType;

export const useLocalStorageStoreType = (defaultStoreType) => {
  let unifiedAppCampaignStoreType = appConfig.get(localStorageKey);
  if (!unifiedAppCampaignStoreType) {
    if (localStorage && localStorage.supportsStorage()) {
      unifiedAppCampaignStoreType = localStorage.get(localStorageKey);
      appConfig.set(localStorageKey, unifiedAppCampaignStoreType);
    }
  }

  return unifiedAppCampaignStoreType || defaultStoreType;
};

export const useCampaignStoreType = (campaign, defaultStoreType) => {
  if (campaign && campaign.CampaignSettings) {
    const appSettings = campaign.CampaignSettings.find(settings => settings['@odata.type'] === '#Model.AppSetting');

    if (appSettings && appSettings.AppStore) {
      return APP_STORE_TO_STORE_TYPE[appSettings.AppStore];
    }
  }
  return defaultStoreType;
};
